import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { reaction } from "mobx";
import styles from "./Header.module.scss";
import logo from "../assets/img/logo.png";
import logoWhite from "../assets/img/logo-white.png";
import Icon from "@material-ui/core/Icon";
import IconCustom from "../components/Icon";
import GeneralStore from "../stores/GeneralStore";
import SearchBox from "./SearchBox";

const Header = () => {
  const generalStore = useContext(GeneralStore);
  const [showWhite, setShowWhite] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpenMenu(false);
  }, [pathname]);

  useEffect(() => {
    // For getting new requests when created new one
    reaction(
      () => generalStore.showWhiteNavbar,
      () => {
        setShowWhite(generalStore.showWhiteNavbar);
      }
    );

    const body = document.querySelector("body");

    if (openMenu) {
      body.style.overflow = "hidden";

      console.log("open menu", body);
    } else {
      body.style.overflow = "auto";
    }
  });

  return (
    <header className={styles.header}>
      <div className="container-fluid">
        <div className="row d-none d-sm-flex">
          <div className={cx("col-12 col-md-3 d-flex justify-content-start", styles.colMobile)}>
            <NavLink exact={true} to="/">
              <div className={styles.logoDiv}>
                <img src={showWhite ? logoWhite : logo} alt="keybudz logo" />
              </div>
            </NavLink>
          </div>
          <div className={cx("col-12 col-md-6 d-flex justify-content-center", styles.colMobile)}>
            <nav className={cx(styles.mainNav, showWhite && styles.white)}>
              <ul>
                <li>
                  <NavLink exact={true} to="/products" activeClassName="active">
                    Products
                  </NavLink>

                  <ul className={styles.subLinks}>
                    <li>
                      <NavLink exact={true} to="/products#AirPods" activeClassName="active">
                        AirPods
                      </NavLink>
                    </li>

                    <li>
                      <NavLink exact={true} to="/products#AirPods Pro" activeClassName="active">
                        AirPods Pro
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink exact={true} to="/about" activeClassName="active">
                    About
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink exact={true} to="/support" activeClassName="active">
                    Support
                  </NavLink>
                </li> */}
              </ul>
            </nav>
          </div>
          <div className={cx("col-12 col-md-3 d-flex justify-content-end", styles.colMobile)}>
            <div className={styles.searchDiv}>
              <SearchBox showWhite={showWhite} />
            </div>
            <div className={cx(styles.wishlistDiv, showWhite && styles.white)}>
              <NavLink exact={true} to="/wishlist" activeClassName="active">
                <Icon>favorite_border</Icon>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="row d-block d-sm-none">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <NavLink exact={true} to="/">
                <div className={styles.logoDiv}>
                  <img src={logo} alt="keybudz logo" />
                </div>
              </NavLink>

              <div
                onClick={() => {
                  setOpenMenu(!openMenu);
                }}
                className={cx(styles.menuButton, openMenu && styles.opened)}
              >
                <div />
                <div />
              </div>
            </div>
          </div>
        </div>

        {openMenu && (
          <div className={styles.mobileMenu}>
            <div className="row">
              <div className="col-12">
                <div className={styles.searchDiv}>
                  <SearchBox isMobile />
                </div>
              </div>
              <div className="col-12">
                <nav className={styles.mainNav}>
                  <ul>
                    <li>
                      <NavLink exact={true} to="/products" activeClassName="active">
                        Products
                      </NavLink>

                      <ul className={styles.subLinks}>
                        <li>
                          <NavLink exact={true} to="/products#AirPods" activeClassName="active">
                            AirPods
                          </NavLink>
                        </li>

                        <li>
                          <NavLink exact={true} to="/products#AirPods Pro" activeClassName="active">
                            AirPods Pro
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink exact={true} to="/about" activeClassName="active">
                        About
                      </NavLink>
                    </li>
                    <li>
                      <NavLink exact={true} to="/wishlist" activeClassName="active">
                        Wishlist
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="col-12">
                <div className={styles.socialDiv}>
                  <IconCustom
                    className="cursor-pointer mr-4"
                    icon="facebook"
                    onClick={() => {
                      window.open("https://www.facebook.com/KeyBudzOfficial", "_blank");
                    }}
                  />

                  <IconCustom
                    className="cursor-pointer mr-4"
                    icon="instagram"
                    onClick={() => {
                      window.open("https://www.instagram.com/keybudz/", "_blank");
                    }}
                  />

                  <IconCustom
                    className="cursor-pointer"
                    icon="twitter"
                    onClick={() => {
                      window.open("https://twitter.com/Keybudz", "_blank");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
